import axiosInstance from "./api";
import TokenService from "./token.service";
import {clearAccountCache} from "@/services/account.service";

const endExpiredSession = () => {
    TokenService.removeTokens();
    clearAccountCache();

    if (window.location.pathname !== "/login") {
        const redirect = window.location.pathname + window.location.search;
        window.location.assign(`/login?redirect=${encodeURIComponent(redirect)}`);
    }
};

const setup = () => {
    axiosInstance.interceptors.request.use(
        (config) => {
            const token = TokenService.getLocalAccessToken();
            if (token) {
                config.headers["Authorization"] = 'Bearer ' + token;
            }
            return config;
        },
        (error) => {
            return Promise.reject(error);
        }
    );

    axiosInstance.interceptors.response.use(
        (res) => {
            return res;
        },
        async (err) => {
            const originalConfig = err.config;

            if (originalConfig.url !== "/login" && originalConfig.url !== "/refreshToken" && err.response) {
                // Access Token was expired
                if (err.response.status === 401 && !originalConfig._retry) {
                    originalConfig._retry = true;
                    try {
                        const rs = await axiosInstance.post("/refreshToken", {
                            refreshToken: TokenService.getLocalRefreshToken(),
                        });

                        const {access_token: accessToken, expires_in: expiresIn} = rs.data;

                        //TODO зачем-то ложится в хранилище
                        //store.dispatch('auth/refreshToken', accessToken);

                        //@ts-ignore
                        TokenService.updateLocalAccessToken(accessToken, expiresIn);

                        return axiosInstance(originalConfig);
                    } catch (_error) {
                        endExpiredSession();
                        return Promise.reject(_error);
                    }
                }
            }

            if (err.response?.status === 401) {
                endExpiredSession();
            }

            return Promise.reject(err);
        }
    );
};

export default setup;
